import React from 'react';
import PropTypes from 'prop-types';
import PageHeader from 'Components/ComponentLibrary/Molecules/PageHeader';

const Header = ({ clients }) => {
  const primary = (clients.find(client => client.attributes.isPrimary) || {})
    .attributes;
  const spouse = (clients.find(client => !client.attributes.isPrimary) || {})
    .attributes;

  // If there is only a primary client, display: "first last"
  // If there is a spouse with the same last name, display: "primaryFirst & spouseFirst last"
  // If there is a spouse with a different last name, display: "primaryFirst primaryLast & spouseFirst spouseLast"

  let names = '';
  if (primary && primary.firstName) {
    names = `${names} ${primary.firstName}`;
  }
  if (!spouse && primary) {
    names = `${names} ${primary.lastName}`;
  }
  if (spouse && primary && spouse.lastName === primary.lastName) {
    names = `${names} & ${spouse.firstName} ${primary.lastName}`;
  }
  if (spouse && primary && spouse.lastName !== primary.lastName) {
    names = `${names} ${primary.lastName} & ${spouse.firstName} ${spouse.lastName}`;
  }
  names = names.trim();

  return (
    <PageHeader title="Blueprint" subtitle={names} />
  );
};

Header.propTypes = {
  clients: PropTypes.array,
};

Header.defaultProps = {
  clients: [],
};

export default Header;
